import type { AppRoleName } from './registryClient';
import { submitToRegistry } from './registryClient';
import {
  buildApplicationEnvelope,
  type ApplicationPublicMeta,
} from './applicationEnvelope';
import type { SealedInsert } from './sealApplication';
import { serverPinJson, type PinJsonFn } from './serverApi';
import type { SessionProof } from './serverContract';
import type { Eip1193Provider } from './walletConnect';

export async function persistAndSubmitApplication(opts: {
  sealed: SealedInsert;
  role: AppRoleName;
  rawProvider: Eip1193Provider;
  chainId: number;
  publicMeta: ApplicationPublicMeta;
  /** Wallet sign-in proof for the pinata-pin function (see ensureSessionProof). */
  session?: SessionProof;
  pinJson?: PinJsonFn;
  submit?: typeof submitToRegistry;
}): Promise<{ txHash: string; applicationId: number; uri: string }> {
  const envelope = buildApplicationEnvelope(opts.sealed, opts.publicMeta);
  if (envelope.public.role !== opts.role) {
    throw new Error(`Sealed role ${envelope.public.role} does not match submit role ${opts.role}`);
  }

  let pin = opts.pinJson;
  if (!pin) {
    if (!opts.session) throw new Error('Sign in with your wallet to submit.');
    pin = serverPinJson(opts.session);
  }
  const { uri } = await pin(envelope, `sf-${opts.role}-did-${opts.sealed.did_id}.json`);

  const submit = opts.submit ?? submitToRegistry;
  const onChain = await submit({
    rawProvider: opts.rawProvider,
    chainId: opts.chainId,
    role: opts.role,
    contentHash: opts.sealed.content_hash,
    uri,
  });
  return { ...onChain, uri };
}
